import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// DRUG_LIST_UPDATE_DELETE_ATTACHMENT

const mutation = gql`
  mutation drugListUpdateRequestDeleteAttachment($id: ID!) {
    drugListUpdateRequestDeleteAttachment(id: $id) {
      id
      form_attachment {
        id
      }
    }
  }
`
export default function useDrugListUpdateRequestDeleteAttachment() {
  const { onMutate: onDrugListUpdateRequestAttachmentDelete, loading } =
    useSafeRunMutation({
      mutation,
      responsePath: 'drugListUpdateRequestDeleteAttachment',
      successMessage: 'Attachment deleted'
    })

  return { onDrugListUpdateRequestAttachmentDelete, loading }
}
